// application types
export const CONNECT = 'connect';
export const IDE = 'ide';
export const JUPYTER = 'jupyter';
export const SHINY = 'shiny';

export const isContentSource = (app) => app?.type === IDE || app?.type === JUPYTER || app?.type === CONNECT;

export const isShiny = (app) => app?.type === SHINY;
